import { render, staticRenderFns } from "./FormEndTab.vue?vue&type=template&id=6f190cd6&"
import script from "./FormEndTab.vue?vue&type=script&lang=ts&"
export * from "./FormEndTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f190cd6')) {
      api.createRecord('6f190cd6', component.options)
    } else {
      api.reload('6f190cd6', component.options)
    }
    module.hot.accept("./FormEndTab.vue?vue&type=template&id=6f190cd6&", function () {
      api.rerender('6f190cd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/building/components/FormEndTab.vue"
export default component.exports